import eligiblestudentsbyentity from './eligiblestudentsbyentity.route'
import onlinepreregistration from './online-pre-registration.route'
import referralsPartCtoPartB from './referrals-part-c-to-part-b.route'
import teachersForStudents from './teachers-for-students.route'
import specialistScheduleRoute from './specialist-schedule.route'
import parentInventory from './parent-inventory.route'

const routes = [
  {
    path: '',
    component: () =>
      import('@/views/general-reports/GeneralReportsWrapper.vue'),
    children: [
      {
        path: '/',
        name: 'general',
        component: () => import('@/views/general-reports/Menu.vue'),
      },
      eligiblestudentsbyentity,
      onlinepreregistration,
      referralsPartCtoPartB,
      teachersForStudents,
      specialistScheduleRoute,  
      parentInventory,
    ],
  },
]

export default routes
